export const scriptContent = [
	"window.fwSettings={'widget_id':61000000347};",
	"!function(){if('function'!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}('hide')"
].join('\n')

export const scriptUrl = 'https://widget.freshworks.com/widgets/61000000347.js'